import { gate } from 'hub-http/gates';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useIsUngated } from 'ai-components-ui-library/hooks/useIsUngated';
import unescapedText from 'I18n/utils/unescapedText';
import { copilotV2MessageToMessageWithSections } from './utils/copilotMessageMapUtils';
import { Small } from 'foundations-components/transitional/components/Small';
import SimpleMessageSectionDisabled from '../../conversational/SimpleMessageSectionDisabled';
import { isSimplifiedPreviewResult, isV2PreviewMessage } from './utils/previewMigrationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CopilotPreviewDisabledState = ({
  overrideDisabled,
  previousGeneratedPreview,
  children
}) => {
  var _overrideDisabled$dis, _overrideDisabled$dis2;
  const isUngatedForSimplifiedPreviews = useIsUngated(gate('CopilotPreviewsV2:Simplified'));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      gap: "200",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(Tooltip, {
        delay: BREEZE_TOOLTIP_DELAY,
        title: unescapedText('aiAddonCopilotPreview.components.copilotPreviewInner.disabledTooltip'),
        disabled: Boolean(overrideDisabled === null || overrideDisabled === void 0 ? void 0 : overrideDisabled.disabledSubtitle),
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          color: "text-core-subtle",
          children: (_overrideDisabled$dis = overrideDisabled === null || overrideDisabled === void 0 ? void 0 : overrideDisabled.disabledSubtitle) !== null && _overrideDisabled$dis !== void 0 ? _overrideDisabled$dis : unescapedText('aiAddonCopilotPreview.components.copilotPreviewInner.disabledSubtitle')
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(Small, {
        tagName: "div",
        "data-test-id": "preview-summary",
        children: [previousGeneratedPreview.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [isUngatedForSimplifiedPreviews && previousGeneratedPreview.length > 0 && isSimplifiedPreviewResult(previousGeneratedPreview[0]) && previousGeneratedPreview.map((preview, index) => {
            const key = `disabled-simplified-${index}-${preview.createdAt}`;
            return /*#__PURE__*/_jsx(SimpleMessageSectionDisabled, {
              section: preview.llmResponse[0]
            }, key);
          }), previousGeneratedPreview.length > 0 && isV2PreviewMessage(previousGeneratedPreview[0]) && previousGeneratedPreview.map((message, index) => {
            const mapToV1Message = copilotV2MessageToMessageWithSections(message);
            return mapToV1Message.sections.map((section, sectionIndex) => /*#__PURE__*/_jsx(SimpleMessageSectionDisabled, {
              section: section
            }, `disabled-message-${index}-section-${sectionIndex}-${section.id}`));
          })]
        }), previousGeneratedPreview.length === 0 && /*#__PURE__*/_jsx(View, {
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            children: (_overrideDisabled$dis2 = overrideDisabled === null || overrideDisabled === void 0 ? void 0 : overrideDisabled.disabledDescription) !== null && _overrideDisabled$dis2 !== void 0 ? _overrideDisabled$dis2 : unescapedText('aiAddonCopilotPreview.components.copilotPreviewInner.disabledDescription')
          })
        })]
      })
    }), children]
  });
};